import ModuleListStore from '../_stores/ModuleListStore';
import { delegateReducer } from '@af-common/Common/Utils/ImmutableDelegateReducer';
import { ModuleAction, ModuleActionType } from '../../Module/_actions/ModuleActions';
import { ModuleListAction, ModuleListActionType } from '../_actions/ModuleListActions';
import { LayerListAction, LayerListActionType } from '../../LayerList/_actions/LayerListActions';

const ModuleListReducer = (store:ModuleListStore = new ModuleListStore(), action: LayerListAction | ModuleListAction | ModuleAction):ModuleListStore => {
	switch (action.type) {
		case LayerListActionType.OnLayerSelect:
			store = store.set('selectedModuleId', null);

		case LayerListActionType.OnLayerRemove:
			store = store.set('selectedModuleId', null);
	}

	switch (action.type) {
		case ModuleListActionType.OnModuleRemove:
			return store.set('modules', store.get('modules').delete(action.id));
		
		case ModuleListActionType.OnModuleSelect:
			return store.set('selectedModuleId', action.id);
	}

	return store;
}

export default ModuleListReducer